import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { useTranslation } from 'react-i18next';
import { IRequestDepartmentTranscode } from '../types';

interface RequestDepartmentTranscodeFormProps {
  transcode: IRequestDepartmentTranscode;
  onSubmit: any;
}
function RequestDepartmentTranscodeForm({
  transcode,
  onSubmit
}: RequestDepartmentTranscodeFormProps) {
  const { t } = useTranslation();

  return (
    <div>
      {transcode && (
        <EnhancedForm onSubmit={onSubmit} edit={!!transcode.id} autoStyleLayout columns={2}>
          <IdentityField
            name="department"
            component={TextFieldAdapter}
            initialValue={transcode.department}
            label={t('global.department')}
            placeholder={t('global.department')}
            type="text"
          />
          <IdentityField
            name="laboratory"
            component={TextFieldAdapter}
            initialValue={transcode.laboratory}
            label={t('global.laboratory')}
            placeholder={t('global.laboratory')}
            type="text"
          />
        </EnhancedForm>
      )}
    </div>
  );
}

export default RequestDepartmentTranscodeForm;
